import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';

import { IconComponent } from '@app/shared/components/icon/icon.component';

@Component({
  selector: 'lum-ui-copyable',
  templateUrl: './ui-copyable.component.html',
  styleUrls: ['./ui-copyable.component.scss'],
  standalone: true,
  imports: [CommonModule, IconComponent, MatDividerModule, MatTooltipModule],
})
export class UiCopyableComponent {
  @Input() content :string | number | null = null;

  onCopy(event :MouseEvent) :void {
    event.stopPropagation();
    event.preventDefault();

    if (this.content) {
      navigator.clipboard.writeText(String(this.content));
    }
  }

  onContentFocus(event :FocusEvent) :void {
    (event.target as HTMLInputElement).select();
  }
}
